const pushPart = (parts, condition, text) => {
  if (condition) parts.push(text);
};

/** Backend plantFoodBuffEffectSummary ile aynı özet metin. */
export const summarizeCropConsumeBuff = (buff, durationMinutes) => {
  if (!buff || typeof buff !== 'object') return '';
  const parts = [];
  pushPart(parts, buff.attackPowerPercent > 0, `+${buff.attackPowerPercent}% Saldırı Gücü`);
  pushPart(parts, buff.defensePercent > 0, `+${buff.defensePercent}% Savunma`);
  pushPart(parts, buff.defenseFlat > 0, `+${buff.defenseFlat} Savunma`);
  pushPart(parts, buff.attackSpeedPercent > 0, `+${buff.attackSpeedPercent}% Saldırı Hızı`);
  pushPart(parts, buff.hpProductionPercent > 0, `+${buff.hpProductionPercent}% HP Yenileme`);
  pushPart(parts, buff.maxHpFlat > 0, `+${buff.maxHpFlat} HP`);
  pushPart(parts, buff.criticalChancePercent > 0, `+${buff.criticalChancePercent}% Kritik`);
  pushPart(parts, buff.experiencePercent > 0, `+${buff.experiencePercent}% EXP`);
  pushPart(parts, buff.skillDamagePercent > 0, `+${buff.skillDamagePercent}% Beceri Hasarı`);
  pushPart(parts, buff.spProductionPercent > 0, `+${buff.spProductionPercent}% SP Yenileme`);
  pushPart(parts, buff.fireResistPercent > 0, `+${buff.fireResistPercent}% Ateş Direnci`);
  pushPart(parts, buff.waterResistPercent > 0, `+${buff.waterResistPercent}% Su Direnci`);
  pushPart(parts, buff.earthResistPercent > 0, `+${buff.earthResistPercent}% Toprak Direnci`);
  pushPart(parts, buff.magicResistPercent > 0, `+${buff.magicResistPercent}% Büyü Direnci`);
  pushPart(parts, buff.healHpPercent > 0, `+${buff.healHpPercent}% HP İyileşme`);
  if (!parts.length) return '';
  const mins = Number(durationMinutes) || Number(buff.durationMinutes) || 0;
  if (mins > 0) {
    return `${parts.join(', ')} (${mins} dk)`;
  }
  return parts.join(', ');
};

const cropHasUsableBuff = (crop) => {
  const b = crop?.consumeBuff;
  if (!b) return false;
  return Number(b.durationMinutes) > 0 || Number(b.healHpPercent) > 0;
};

/** /api/farming/config cevabından envanter kullanım bilgisi üretir. */
export const farmFoodConfigFromResponse = (data) => {
  if (data?.opening?.usableCropOtherIds) {
    return data.opening;
  }
  const crops = data?.config?.crops;
  if (!Array.isArray(crops)) return null;

  const usableCropOtherIds = [];
  const cropFoodEffects = {};
  const seen = new Set();

  crops.forEach((crop) => {
    const id = Number(crop?.cropOtherItemId);
    if (!id || !cropHasUsableBuff(crop) || seen.has(id)) return;
    seen.add(id);
    usableCropOtherIds.push(id);
    const summary = summarizeCropConsumeBuff(crop.consumeBuff, crop.consumeBuff?.durationMinutes);
    if (summary) {
      cropFoodEffects[id] = summary;
    }
  });

  return { usableCropOtherIds, cropFoodEffects };
};
